import { useState } from 'react';

interface UsePaginationProps {
  initialPage?: number;
  initialPageSize?: number;
}

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 25;

export const usePagination = (props?: UsePaginationProps) => {
  const [page, setPage] = useState(props?.initialPage ?? DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState(props?.initialPageSize ?? DEFAULT_PAGE_SIZE);

  return { page, pageSize, setPage, setPageSize };
};
